<template>
  <b-modal width="680px" :active.sync="isModalSeekerSearchActive" :on-cancel="cancel">
    <div class="card -card">
      <!-- タイトル -->
      <header class="card-header -header">
        <p class="card-header-title title">
          応募者検索
        </p>
      </header>
      <div class="basic-modal-content">
        <p class="sub-title">応募者の紐づけ候補</p>
        <div class="description">
          <!-- 選択候補の表示 -->
          <p style="text-align: left; font-weight: 600; padding-top: 16px;">
            以下の候補から選択してください。
          </p>
          <p style="text-align: left; font-weight: 600;">
            候補にない場合は検索結果から選択が可能です。
          </p>
          <!-- 検索結果一覧 -->
          <div>
            <SelectItemList
              style="width: 100%; padding: 16px;"
              :header="header"
              :itemList="getDispList(candidateList)"
              @select-item="selectSeeker"
            />
          </div>
        </div>
        <!-- 応募者の検索 -->
        <hr>
        <p class="sub-title">応募者の検索</p>
        <div class="description">
          <!-- 名前の入力 -->
          <b-field>
            <p style="text-align: left; font-weight: 600; width: 10%;">名前</p>
            <input
              style="width: 70%; is-small"
              v-model="searchName"
            />
          </b-field>
          <!-- Emailの入力 -->
          <b-field>
            <p style="text-align: left; font-weight: 600; width: 10%;">Email</p>
            <input
              style="width: 70%; is-small"
              v-model="searchEmail"
            />
          </b-field>
          <!-- 検索ボタン -->
          <div class="buttons-wrapper">
            <button class="button is-small" @click="search(searchName, searchEmail)">検索</button>
          </div>
          <!-- 対象の選択 -->
          <p style="text-align: left; font-weight: 600; padding-top: 16px;">
            以下の候補から選択してください。
          </p>
          <!-- 検索結果一覧 -->
          <div>
            <SelectItemList
              style="width: 100%; padding: 16px;"
              :header="header"
              :itemList="getDispList(searchList)"
              @select-item="selectSeeker"
            />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SelectItemList from '@/components/organisms/common/SelectItemList'

export default {
  name: 'ModalSeekerSearch',
  components: {
    /** アイテム一覧 */
    SelectItemList,
  },
  props: {
    /** モーダルダイアログ開閉フラグ */
    isSeekerSearchDialogOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** 初期検索情報(名前) */
    initName  : {
      type    : String,
      default : '',
      required: true,
    },
    /** 初期検索情報(Email) */
    initEmail : {
      type    : String,
      default : '',
      required: true,
    }
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isModalSeekerSearchActive: this.isSeekerSearchDialogOpen,
      /** 名前検索 */
      searchName           : '',
      /** Email検索 */
      searchEmail          : '',
      /** 初期候補リスト */
      candidateList        : [],
      /** 検索結果リスト */
      searchList           : [],
      /** リストヘッダ */
      header               : [
        '名前',
        'Email'
      ]
    }
  },
  computed: {
    getDispList () {
      return function (seekerList) {
        let dispList = []
        if (seekerList) {
          for (const seeker of seekerList) {
            dispList.push([seeker, seeker.name, seeker.email])
          }
        }
        return dispList
      }
    }
  },
  watch: {
    /** モーダルダイアログ開閉フラグ */
    isSeekerSearchDialogOpen () {
      this.isModalSeekerSearchActive = this.isSeekerSearchDialogOpen
      if (this.isSeekerSearchDialogOpen === true) {
        if (this.initName && this.initEmail) {
          // 初期候補取得
          const searchInfo = {
            name : this.initName  ? this.initName  : 'no-entory',
            email: this.initEmail ? this.initEmail : 'no-entory'
          }
          this.$store.dispatch('directtalk/searchSeeker', searchInfo)
            .then((seeker) => {
              this.candidateList = seeker
            })
        }
      }
    }
  },
  methods: {
    /** 検索 */
    search (name, email) {
      // 検索条件
      const searchInfo = {
        name : name  ? name  : 'no-entory',
        email: email ? email : 'no-entory'
      }
      // 検索
      this.$store.dispatch('directtalk/searchSeeker', searchInfo)
        .then((seeker) => {
          this.searchList = seeker
        })
    },
    /** Seeker選択 */
    selectSeeker (object) {
      this.$emit('select-seeker', object)
      this.cancel()
    },
    /** ダイアログを閉じる */
    cancel () {
      // 検索結果初期化
      this.searchName    = ''
      this.searchEmail   = ''
      this.candidateList = []
      this.searchList    = []
      this.$emit('close-seeker-search')
    }
  }
}
</script>

<style lang="scss" scoped>
.-card {
  width: 100%;
  border-radius: 8px;
}
.-header {
  width: 100%;
  p {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.basic-modal-content {
  padding: 8px;
  height: 480px;
  text-align: center;
  overflow: scroll;
  .description {
    width: 100%;
    text-align: left;
    p {
      font-size: 12px;
    }
  }
  .buttons-wrapper {
    margin-top: 24px;
    .selected {
      background: rgb(221, 221, 221);
    }
  }
  .sub-title {
    text-align: left;
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalSeekerSearch.vue